import {RegionalCostsPath} from './routePaths';

const navHorizontalOptions = [
  {
    name: 'Vehicle costs',
    path: RegionalCostsPath.vehicleCosts
  },
  {
    name: 'Driver costs',
    path: RegionalCostsPath.driverCosts
  },
  {
    name: 'Driver salary periods',
    path: RegionalCostsPath.driverSalaryPeriods
  }
];

export default navHorizontalOptions;
